module.exports = __webpack_public_path__ + "static/media/27OCHA17.19824882.jpg";